// Mirror of backend-nest/src/agents/constants/configurable-agents.ts.
//
// The agent types an organization can enable or disable through
// `AgentConfiguration.enabledAgents` — exactly the toggles AgentConfigCard renders.
// The backend AgentType enum is much wider, and the extras are configured elsewhere
// or not at all: stage_* agents live in StageAgentConfig (per funnel stage),
// *_enrichment types are lead-enrichment prompt kinds, flowsellai_company_research
// is internal, and orchestrator is the always-on chat orchestrator.
//
// The onboarding review screen must filter its generated plan through this set.
// A plan generated before the backend catalog was narrowed still sits in
// OrgOnboardingState.generatedPlan and gets replayed verbatim, so the screen cannot
// assume the backend already cleaned it — offering one of those toggles hands the
// user a switch they can never find again on the Agents screen.
export const ORG_CONFIGURABLE_AGENT_TYPES: ReadonlySet<string> = new Set<string>([
  'lead_qualification',
  'lead_enrichment',
  'follow_up_scheduler',
  'sentiment_analysis',
  'prompt_enricher',
  'linkedin_company_research',
  'browser_company_research',
  'instagram_company_research',
]);

export function isOrgConfigurableAgent(type: string): boolean {
  return ORG_CONFIGURABLE_AGENT_TYPES.has(type);
}
